import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Message from '../../components/ui/Message';
import logoClickLink from '../../assets/images/logo_clicklink.png';
import { BRAND_NAME, SITE_URL } from '../../utils/appConfig';
import './linkpago.css';
import '../login/auth.css';
import { Link } from '../../models/interfaces';
import { LinkPagoContext } from '../../context/linkPago/LinkPagoContext';
import moment from 'moment';
import { CardInput } from './CardInput';


const LinkPago = () => {
    const navigate = useNavigate();
    const { isLoading, loadLinkPagoExternal, linkExternal, autorizationLink, isLoadingAutorization, isRequireName } = useContext(LinkPagoContext);

    const [form, setForm] = useState({
        name: '',
        card: '',
        exp: '',
        cvv: ''
    });

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [existLink, setExistLink] = useState('');
    const [card, setCard] = useState("");
    const [mostrarRequeridos, setMostrarRequeridos] = useState(false);
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");





    useEffect(() => {
        const token = getTokenFromUrl(window.location.href);
        if (token != null) {
            loadLinkPagoExternal(token).then((message) => {
                if (message != 'success') {
                    setExistLink(message);

                } else { localStorage.setItem("linkToken", token); }
            });
        }
    }, []);

    const months = [
        { value: "01", label: "Enero" },
        { value: "02", label: "Febrero" },
        { value: "03", label: "Marzo" },
        { value: "04", label: "Abril" },
        { value: "05", label: "Mayo" },
        { value: "06", label: "Junio" },
        { value: "07", label: "Julio" },
        { value: "08", label: "Agosto" },
        { value: "09", label: "Septiembre" },
        { value: "10", label: "Octubre" },
        { value: "11", label: "Noviembre" },
        { value: "12", label: "Diciembre" },
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 20 }, (_, i) => currentYear + i);

    const getTokenFromUrl = (url: string): string | null => {
        const parts = url.split('/');
        return parts.length > 0 ? parts[parts.length - 1] : null;
    };

    const { name, cvv } = form;

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        // Solo números para ciertos campos
        if (e.target.classList.contains('onlyInteger') && !/^[0-9]*$/.test(value)) {
            return;
        }

        setForm({
            ...form,
            [name]: value
        });
    };
    const normalizeAmonto = (valor) => {
        // Elimina espacios y reemplaza comas por puntos
        let limpio = String(valor).trim().replace(',', '.');

        // Convierte a número
        let num = parseFloat(limpio);

        // Si no es número válido, retorna 0.00
        if (isNaN(num)) return "0.00";

        // Redondea a 2 decimales, sin alterar valores válidos
        return num.toFixed(2);
    }

    const handlePay = async () => {


        const isFormValid = card.trim().length > 0 && month.trim().length > 0 && year.trim().length > 0 && cvv.trim().length > 0;
        if (!isFormValid) {
            setError('Debe completar todos los campos requeridos');
            setMostrarRequeridos(true)
            return;
        }
        setMostrarRequeridos(false)




        try {

            const clearCard = card.replace(/\s+/g, "");

            const linkCard = {
                "card": clearCard,
                "expiration": month + year.substring(2),
                "cvv": form.cvv,
                "name": form.name,
                "amount": normalizeAmonto(linkExternal.monto),
                "currency": linkExternal.currency,
                "description": linkExternal.descripcion,
                "page_result": `${SITE_URL}/linkpago/result`
            }
            const token = getTokenFromUrl(window.location.href);
            const paymentResponse = await autorizationLink(linkCard, token);

            if (paymentResponse.payResponse.status == "APPROVED") {
                navigate("/linkpago/result", { state: { paymentResponse } });

            } else if (paymentResponse.payResponse.status == "CONFIRMED") {

                const { action, creq, threeDSSessionData } = paymentResponse.payResponse;

                // 🔹 Crear el formulario dinámicamente
                const form = document.createElement("form");
                form.method = "POST";
                form.action = action;
                form.style.display = "none"; // oculto

                // 🔹 Agregar los inputs ocultos requeridos
                const fields = {
                    creq,
                    threeDSSessionData
                };

                Object.entries(fields).forEach(([key, value]) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = key;
                    input.value = value || "";
                    form.appendChild(input);
                });

                // 🔹 Insertar y enviar automáticamente
                document.body.appendChild(form);
                form.submit();
            } else {
                navigate("/linkpago/result", { state: { paymentResponse } });
            }

        } catch (err) {
            setError('Su pago no se completó. Consulta con el comercio para confirmar.');
        } finally {
            //setIsLoading(false);
        }
    };

    const removeLocalError = () => setError('');
    const removeSuccessMessage = () => {
        setSuccess('');
        // navigate(-1);
    };

    const missing = (value: string) => mostrarRequeridos && value.trim().length === 0 ? 'is-invalid' : '';

    // Estado de pantalla completa (procesando / cargando / enlace no válido)
    const renderCentered = (content: React.ReactNode) => (
        <div className="auth-page">
            <main className="auth-main">
                <div className="auth-card text-center">{content}</div>
            </main>
        </div>
    );

    const renderContent = () => {
        if (isLoadingAutorization) {
            return renderCentered(
                <>
                    <div className="spinner-border text-primary mb-4" role="status" style={{ width: '2.5rem', height: '2.5rem' }}>
                        <span className="visually-hidden">Procesando pago...</span>
                    </div>
                    <h5 className="fw-bold mb-2">Procesando su pago</h5>
                    <p className="text-muted mb-0">
                        Espere unos segundos mientras confirmamos la transacción.<br />
                        <span className="fw-semibold text-danger">No cierre esta ventana.</span>
                    </p>
                </>
            );
        }

        if (isLoading) {
            return renderCentered(
                <>
                    <div className="spinner-border text-primary" role="status" />
                    <p className="mt-3 mb-0 text-muted">Cargando el link de pago...</p>
                </>
            );
        }

        if (existLink.length > 0) {
            return renderCentered(
                <>
                    <img src={logoClickLink} alt="ClickLink by SwiftPay" className="d-block mx-auto mb-3" style={{ height: 56, maxWidth: '100%' }} />
                    <div className="auth-icon is-danger mb-3">
                        <i className="bi bi-link-45deg" />
                    </div>
                    <h4 className="mb-2">Enlace no válido</h4>
                    <p className="text-muted mb-0">{existLink}</p>
                </>
            );
        }

        return (
            <div className="auth-page">

                <main className="auth-main">
                    <div className="auth-card auth-card-wide">

                        {/* Monto a pagar */}
                        <div className="text-center mb-4">
                            <img src={logoClickLink} alt="ClickLink by SwiftPay" className="mb-3" style={{ height: 64, maxWidth: '100%' }} />
                            <div className="text-muted small mb-1">
                                <i className="bi bi-shop me-1" />{linkExternal.nombreComercio}
                            </div>
                            <div className="text-muted small">Monto a pagar</div>
                            <div className="auth-amount">{getAmount(linkExternal)}</div>
                            {linkExternal.descripcion && <div className="text-muted mt-2">{linkExternal.descripcion}</div>}
                        </div>

                        {/* Detalle del link */}
                        <div className="border rounded-3 bg-light p-3 mb-4">
                            {[
                                { label: 'Cliente', value: linkExternal.nombreCliente, icon: 'bi-person' },
                                { label: 'Referencia', value: linkExternal.referencia, icon: 'bi-hash' },
                                { label: 'Vence', value: moment(linkExternal.fechaVencimiento).format('DD/MM/YYYY'), icon: 'bi-calendar-event' },
                            ].filter(item => item.value).map((item) => (
                                <div key={item.label} className="d-flex justify-content-between gap-3 small py-1">
                                    <span className="text-muted"><i className={`bi ${item.icon} me-2`} />{item.label}</span>
                                    <span className="fw-medium text-end">{item.value}</span>
                                </div>
                            ))}
                        </div>

                        {/* Datos de la tarjeta */}
                        <h6 className="mb-3"><i className="bi bi-credit-card me-2 text-primary" />Datos de la tarjeta</h6>

                        <div className="row g-0">
                            <div className={isRequireName ? "mb-3 col-12" : "mb-3 col-12 visually-hidden"}>
                                <label htmlFor="name" className="form-label small text-muted mb-1">Nombre en la tarjeta *</label>
                                <div className="input-group">
                                    <span className="input-group-text"><i className="bi bi-person" /></span>
                                    <input
                                        id="name"
                                        name="name"
                                        type="text"
                                        autoComplete="cc-name"
                                        className="form-control"
                                        placeholder="Como aparece en la tarjeta"
                                        value={name}
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>

                            <div className={`col-12 ${mostrarRequeridos && card.trim().length === 0 ? 'link-card-missing' : ''}`}>
                                <CardInput card={card} setCard={setCard} />
                            </div>
                        </div>

                        <div className="row g-3">
                            <div className="col-sm-7">
                                <label htmlFor="expMonth" className="form-label small text-muted mb-1">Fecha de vencimiento *</label>
                                <div className="d-flex gap-2">
                                    <select
                                        id="expMonth"
                                        className={`form-select ${missing(month)}`}
                                        value={month}
                                        onChange={(e) => setMonth(e.target.value)}
                                    >
                                        <option value="">Mes</option>
                                        {months.map((m) => (
                                            <option key={m.value} value={m.value}>{m.value} - {m.label}</option>
                                        ))}
                                    </select>

                                    <select
                                        id="expYear"
                                        className={`form-select ${missing(year)}`}
                                        value={year}
                                        onChange={(e) => setYear(e.target.value)}
                                    >
                                        <option value="">Año</option>
                                        {years.map((y) => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-sm-5">
                                <label htmlFor="cvv" className="form-label small text-muted mb-1">Código de seguridad *</label>
                                <div className="input-group">
                                    <span className="input-group-text"><i className="bi bi-shield-lock" /></span>
                                    <input
                                        id="cvv"
                                        name="cvv"
                                        type="password"
                                        inputMode="numeric"
                                        autoComplete="cc-csc"
                                        className={`form-control onlyInteger ${missing(cvv)}`}
                                        maxLength={4}
                                        placeholder="CVV"
                                        value={cvv}
                                        onChange={onInputChange}
                                    />
                                </div>
                            </div>
                        </div>

                        {mostrarRequeridos && <div className="small text-danger mt-2">* Complete los campos requeridos.</div>}

                        {/* Pagar */}
                        <button onClick={handlePay} className="btn btn-primary w-100 mt-4" disabled={isLoading}>
                            <i className="bi bi-lock-fill me-1" /> Pagar {getAmount(linkExternal)}
                        </button>
                        <p className="text-center text-muted small mt-3 mb-0">
                            <i className="bi bi-shield-check me-1" />
                            Pago seguro. Su banco puede solicitarle una verificación adicional.
                        </p>
                    </div>
                </main>

                <footer className="auth-footer">© {new Date().getFullYear()} {BRAND_NAME}</footer>
            </div>
        );
    };

    return (
        <div>
            {renderContent()}

            {/* Mensajes locales */}
            {
                error.length > 0 && (
                    <Message
                        type="error"
                        message={error}
                        closeDialog={removeLocalError}
                        handleOk={removeLocalError}
                        backgroundColor="rgba(0,0,0,0.4)"
                    />
                )
            }

            {
                success.length > 0 && (
                    <Message
                        type="success"
                        title="Exitoso"
                        message={success}
                        closeDialog={removeSuccessMessage}
                        handleOk={removeSuccessMessage}
                        backgroundColor="rgba(0,0,0,0.4)"
                    />
                )
            }
        </div >
    );
};


function getAmount(link: Link): React.ReactNode {
    let amount = link.monto;
    amount = amount;
    return formatMoney(amount) + " " + link.currency;
}

function formatMoney(amount) {
    const formatNumber = (number: number, decimalCount: number = 2, decimal: string = ",", thousands: string = ".") => {
        return number.toLocaleString(undefined, {
            minimumFractionDigits: decimalCount,
            maximumFractionDigits: decimalCount,
            useGrouping: true,
            currency: undefined,
            style: 'decimal',
        });
    };


    return formatNumber(amount);
};

export default LinkPago;
